module.exports = __webpack_public_path__ + "img/tu07.06d1c09b.png";